import * as logger from "common/logger";
import * as strings from "common/strings";
import { JSONPath } from "jsonpath-plus";
import { createSelector as _createSelector } from "reselect";

export const createSelector = (inputSelectors, outputSelector) => {
  return _createSelector(inputSelectors, outputSelector, {
    memoizeOptions: {
      maxSize: 10,
    },
  });
};

export const selectPriorState = (state) => state?.temp?.priorState?.state ?? {};

export const dynamicStateSelector = (path) => {
  if (strings.hasValue(path) && path.startsWith("$")) {
    return (state) => {
      try {
        return JSONPath({ json: state, path, wrap: false });
      } catch (e) {
        logger.exception(e);
        return undefined;
      }
    };
  } else {
    const parts = strings.hasValue(path) ? path.split(".") : [];
    return (state) => parts.reduce((state, part) => state?.[part], state);
  }
};
